<template>
	<div class="w-100 p-3 bg-white border-15 overflow-auto">
		<div v-if="$localStorage.get('user').username.role==2 && (flds.sheba_number==null || flds.sheba_number=='')">
			<textInput
			label="کد شبا"
			@inputTxtFunc = "(e)=>{sheba_number = e}"
			/>
			<btn 
			class="mt-3 w-100"
			textClass="w-100"
			text="ذخیره"
			@clickMe="sav()"
			/>
		</div>
		<table class="table" v-else>
			<tr v-if="$localStorage.get('user').username.role==2">
				<td colspan="10" class="text-left">
					<b>کد شبا:</b>
					{{flds.sheba_number}}
					&nbsp;
					<span class="text-danger pointer" @click="()=>{flds.sheba_number=''}">
						(ویرایش)
					</span>
				</td>
			</tr>
			<tr class="border">
				<td class="bMikhak p-3 text-center">
					نام و نام‌خانوادگی
				</td>
				<td class="bMikhak p-3 text-center">
					تاریخ واریز
				</td>
				<td class="bMikhak p-3 text-center">
					مبلغ(تومان)
				</td>
				<td class="bMikhak p-3 text-center">
					کد پرداخت
				</td>
				<td class="bMikhak p-3 text-center">
					وضعیت
				</td>
			</tr>
			<tr v-for="(f, i) in flds.content" :key="i">
				<td class="text-center">
					{{f.teachers_fullname}}
				</td>
				<td dir="ltr" class="yekan text-center">
					{{f.date}}
					{{f.time}}
				</td>
				<td class="yekan text-center">
					{{f.price}}
				</td>
				<td class="text-center">
					{{f.prdCod}}
				</td>
				<td
					class="text-center"
					:class="'text-'+f.status_class"
				>
					{{f.status_name}}
				</td>
			</tr>
		</table>


		<div 
		class="w-100" 
		style="display: flex; align-items: center; justify-content: center;"
		v-if="!($localStorage.get('user').username.role==2 && (flds.sheba_number==null || flds.sheba_number==''))"
		>
			<pageNavigation :page="flds.curPage" :pages="flds.totalPages" @setPage="setPage"  />
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		import pageNavigation from  "../../UI/pageNavigation/pageNavigation.vue";
		import textInput from  "../../UI/input/textInput.vue";
		import { success, error } from "../../assets/library/messege.js";
		
		export default {
			name: 'teachers_part1',
			data(){
				return {
					sheba_number: "",
					error: error,
					success: success,
				}
			},
			components: {
				btn,
				pageNavigation,
				textInput,
			},
			props: {
				flds: {
					default: [],
				},
			},
			mounted(){

			},
			methods:{
				setPage(page){
					this.$emit('setPage', page);
				},
				sav(THIS = this){
					let id = this.$localStorage.get("user").username.id;
					if(this.sheba_number==""){
						this.error(this)
					} else {
						window.$.post(window.baseurl + 'accountTeacher/step_teacher', {
							fild: "sheba_number" ,val: this.sheba_number, id: id,
							token: this.$localStorage.get("user")

						}, function () {
							THIS.success(THIS);
							THIS.flds.sheba_number = THIS.sheba_number;
						}, "json");
					}
				}
			}
		}
	</script>
<style>

</style>
